const TRACKED_SCHEDULE_STATUSES = new Set(["upcoming", "completed"]);

export function parseScheduleDate(value) {
  const match = String(value ?? "").match(/(\d{4})[.-](\d{1,2})[.-](\d{1,2})/);
  if (!match) return null;

  const year = Number(match[1]);
  const month = Number(match[2]);
  const day = Number(match[3]);
  const date = new Date(year, month - 1, day);

  if (
    Number.isNaN(date.getTime()) ||
    date.getFullYear() !== year ||
    date.getMonth() !== month - 1 ||
    date.getDate() !== day
  ) {
    return null;
  }

  return date;
}

export function formatScheduleDateLabel(value) {
  const date = parseScheduleDate(value);
  if (!date) return String(value ?? "").split("(")[0] || "일정 확인";
  return `${date.getMonth() + 1}월 ${date.getDate()}일`;
}

export function formatScheduleDday(value, now = new Date()) {
  const date = parseScheduleDate(value);
  if (!date) return "일정 확인";

  const targetDay = Date.UTC(date.getFullYear(), date.getMonth(), date.getDate());
  const today = Date.UTC(now.getFullYear(), now.getMonth(), now.getDate());
  const difference = Math.round((targetDay - today) / 86400000);

  if (difference > 0) return `D-${difference}`;
  if (difference === 0) return "D-DAY";
  return "일정 확인";
}

function compareScheduleDates(left, right) {
  const leftDate = parseScheduleDate(left?.date);
  const rightDate = parseScheduleDate(right?.date);

  if (leftDate && rightDate) return leftDate.getTime() - rightDate.getTime();
  if (leftDate) return -1;
  if (rightDate) return 1;
  return 0;
}

export function getScheduleDashboardSummary(schedules = [], now = new Date()) {
  const source = Array.isArray(schedules) ? schedules : [];
  const trackedSchedules = source.filter((schedule) => TRACKED_SCHEDULE_STATUSES.has(schedule?.status));
  const completedSchedules = trackedSchedules.filter((schedule) => schedule.status === "completed");
  const upcomingSchedules = trackedSchedules
    .filter((schedule) => schedule.status === "upcoming")
    .slice()
    .sort(compareScheduleDates);
  const totalCount = trackedSchedules.length;
  const completedCount = completedSchedules.length;
  const remainingCount = upcomingSchedules.length;
  const completionPercent = totalCount > 0 ? Math.round((completedCount / totalCount) * 100) : 0;
  const nextSchedule = upcomingSchedules[0] || null;

  return {
    totalCount,
    completedCount,
    remainingCount,
    completionPercent,
    nextSchedule,
    nextDateLabel: nextSchedule ? formatScheduleDateLabel(nextSchedule.date) : "",
    nextDday: nextSchedule ? formatScheduleDday(nextSchedule.date, now) : "",
  };
}
